export const checkPressedEnter = (e) => e.key === "Enter";
export const fireOnEnter = (e, callback) => {
    if (checkPressedEnter(e)) {
        callback();
    }
};
